import dayjs from 'dayjs'
import { printHtml } from '@/utils/qzTray/qzTrayClient'
import { labelPrinterConfig } from './inboundLabel'

/**
 * 라벨을 매수만큼 차례로 인쇄한다(qz-tray 는 한 번에 한 작업 — 1.0 은 PRINT_QTY 만큼 printStart 를 불렀다).
 * 실패(qz 미설치·인증정보 없음·프린터 없음)는 그대로 던진다 — 스캔 흐름을 막지 않고 토스트만 띄우는 일은 호출부가 한다.
 */
export const printInboundLabel = async (html: string, copies: number, now = dayjs()): Promise<void> => {
  const config = labelPrinterConfig(now)
  await Array.from({ length: copies }).reduce<Promise<void>>((chain) => chain.then(() => printHtml({ ...config, html })), Promise.resolve())
}
